import {
  ApplyReferralCodeSection,
  Button,
  ErrorAlert,
  GenerateReferralCodeButton,
  LoadingAlert,
  MoneyAlert,
  Section,
  ShareReferralCodeFormInput,
} from '@/components';
import { useReferral } from '@/components/providers/postauth/ReferralProvider';
import APP_CONFIG from '@/config/app';
import { replaceTokensInString } from '@/utils/functionalUtils';
import { REFERRAL } from '@/utils/strings';
import React, { useMemo } from 'react';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const { MAIN_GAP, WHOLESTEP_DECREMENT } = APP_CONFIG.STYLES;
const spacingConfig = {
  containerGap: `gap${MAIN_GAP}`,
  contentGap: `gap${MAIN_GAP}${WHOLESTEP_DECREMENT}`,
};
interface ReferralCodeSectionProps {
  includeApplyReferralCodeSection?: boolean;
}
const ReferralCodeSection: React.FC<ReferralCodeSectionProps> = React.memo(
  ({ includeApplyReferralCodeSection = true }) => {
    const { userReferralCode, hasUsedReferralCode, isLoading, error } =
      useReferral();
    const bodyContent = useMemo(
      () => (
        <div
          className={`flex flex-col ${spacingConfig.containerGap} ${borderClassToVisualizeElementsAndSpacing}`}
        >
          <MoneyAlert
            title={REFERRAL.TITLE}
            description={REFERRAL.DESCRIPTION}
            extraContent={
              <div
                className={`flex flex-col w-full ${spacingConfig.contentGap} ${borderClassToVisualizeElementsAndSpacing}`}
              >
                {userReferralCode ? (
                  <>
                    <ShareReferralCodeFormInput
                      referralCode={userReferralCode}
                    />
                    <Button
                      onClick={() => {
                        const subject = REFERRAL.EMAIL_SUBJECT;
                        const body = replaceTokensInString(
                          REFERRAL.EMAIL_BODY,
                          {
                            referral_code: userReferralCode,
                          },
                        );
                        window.location.href = `mailto:?subject=${encodeURIComponent(
                          subject,
                        )}&body=${encodeURIComponent(body)}`;
                      }}
                      fullWidth
                    >
                      {REFERRAL.INVITE_BUTTON_TEXT}
                    </Button>
                  </>
                ) : (
                  <GenerateReferralCodeButton />
                )}
              </div>
            }
          />
          {includeApplyReferralCodeSection && <ApplyReferralCodeSection />}
        </div>
      ),
      [userReferralCode, hasUsedReferralCode, includeApplyReferralCodeSection],
    );
    if (isLoading) {
      return (
        <LoadingAlert
          title={REFERRAL.LOADING_TITLE}
          description={REFERRAL.LOADING_DESCRIPTION}
        />
      );
    }
    if (error) {
      return (
        <ErrorAlert
          title={REFERRAL.ERROR_TITLE}
          description={REFERRAL.ERROR_DESCRIPTION}
        />
      );
    }
    return <Section headerTitle={REFERRAL.SECTION_TITLE} body={bodyContent} />;
  },
);
ReferralCodeSection.displayName = 'ReferralCodeSection';
export default ReferralCodeSection;
